module.exports = __webpack_public_path__ + "static/media/7.2b8f74df.jpg";